import React, { createContext, useMemo } from 'react';

const EditorContext = createContext();

const useEditor = () => {
  const context = React.useContext(EditorContext);

  if (!context) {
    return { setEditorState: null }
  }

  return context;
};

// `boxId` : renseigné par les éditeurs rattachés à une box du document. Les
// décorateurs Draft sont partagés par tous les éditeurs (instance unique), le
// contexte est leur seul moyen de savoir dans quelle box ils sont rendus.
const EditorProvider = ({ children, setEditorState, editorState, readOnly, boxId }) => {

  const value = useMemo(() => {
    return { setEditorState, editorState, readOnly, boxId }
  }, [setEditorState, editorState, readOnly, boxId])

  return (
    <EditorContext.Provider value={value}>
      {children}
    </EditorContext.Provider>
  );
};

export { EditorProvider, useEditor };
